
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember-data/adapter/-embroider-implicit-modules.js";
import "@ember-data/model/-embroider-implicit-modules.js";
import "@ember-data/serializer/-embroider-implicit-modules.js";
import "@ember-data/store/-embroider-implicit-modules.js";
import "bullitttime-embercomponents/-embroider-implicit-modules.js";
import "bullitttime-embermodelsevent/-embroider-implicit-modules.js";
import "bullitttime-styles/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-data/-embroider-implicit-modules.js";
import "ember-dayjs/-embroider-implicit-modules.js";
import "ember-element-helper/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-page-title/-embroider-implicit-modules.js";
import "ember-render-helpers/-embroider-implicit-modules.js";
import "ember-socket-guru/-embroider-implicit-modules.js";
import "ember-source/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "ember-cli-inject-live-reload/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "@ember/optional-features/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "@embroider/util/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-ref-bucket/-embroider-implicit-modules.js";
import "ember-bootstrap/-embroider-implicit-modules.js";
import "ember-cli-app-version/-embroider-implicit-modules.js";
import "ember-cli-clean-css/-embroider-implicit-modules.js";
import "ember-cli-release/-embroider-implicit-modules.js";
import "ember-cli-uglify/-embroider-implicit-modules.js";
import "ember-cli-terser/-embroider-implicit-modules.js";
import "ember-cli-sri/-embroider-implicit-modules.js";
import "ember-cli-update/-embroider-implicit-modules.js";
import "ember-composable-helpers/-embroider-implicit-modules.js";
import "ember-load-initializers/-embroider-implicit-modules.js";
import "ember-maybe-import-regenerator/-embroider-implicit-modules.js";
import "ember-promise-helpers/-embroider-implicit-modules.js";
import "ember-qunit/-embroider-implicit-modules.js";
import "ember-resolver/-embroider-implicit-modules.js";
import "ember-truth-helpers/-embroider-implicit-modules.js";
import "loader.js/-embroider-implicit-modules.js";
import "@ember/string/-embroider-implicit-modules.js";
